import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { Button } from 'react-bootstrap';

import propDefs from '../proptypes';

class SeeAllHoursButton extends React.Component {
	constructor(props) {
		super(props);
		this.renderDelegate = this.renderDelegate.bind(this);
	}

	renderDelegate({ prefs, labels }) {
		if (!(prefs.showDepartmentsViewAllLink === 'true')) {
			return null;
		}

		const classNames = [prefs.showDepartmentsViewAllLinkButtonLayout];
		const wrapperClass = ['text-center'];
		classNames.push(prefs.showDepartmentsViewAllLinkButtonClasses);
		if (prefs.showDepartmentsViewAllLinkButtonInverse === 'true') {
			classNames.push('btn-inverse');
		}
		if (
			prefs.showDepartmentsViewAllLinkButtonSize &&
			prefs.showDepartmentsViewAllLinkButtonSize !== 'default'
		) {
			classNames.push(
				`btn-${prefs.showDepartmentsViewAllLinkButtonSize}`
			);
		}

		if (prefs.showCurrentDayOnly === 'true') {
			wrapperClass.push('col-md-7 col-lg-8 col-xs-12');
			classNames.push('py-0 pl-0');
		}

		return (
			<div className={wrapperClass.join(' ')}>
				<Button
					onClick={this.props.showModalAction}
					bsStyle={prefs.showDepartmentsViewAllLinkButtonStyle}
					className={classNames.join(' ')}
				>
					{labels.get('SEE_ALL_DEPARTMENT_HOURS')}
				</Button>
			</div>
		);
	}

	render() {
		return <Common render={this.renderDelegate} />;
	}
}

SeeAllHoursButton.propTypes = {
	showModalAction: propDefs.settings.getModalDisplay.isRequired
};

export default SeeAllHoursButton;



// WEBPACK FOOTER //
// ./src/components/SeeAllHoursButton.jsx